// The Co-Gérant keeps the conversation on screen in this tab only (sessionStorage), so a
// layout switch or a reload does not lose it (E-27). A logout must take it away: the next
// person on this device must never see it.
export const CO_GERANT_CHAT_PREFIX = 'coGerantChat_';

export function clearCoGerantChats() {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    const keys = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const k = window.sessionStorage.key(i);
      if (k && k.startsWith(CO_GERANT_CHAT_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => window.sessionStorage.removeItem(k));
  } catch { /* storage blocked: nothing was kept either */ }
}
